// Pure helpers for remote socket events. They return new node objects instead of
// mutating, so per-node memoization (D-020) sees every change. Behaviour matches
// the previous in-place version exactly, including its known quirks.

const applyRemoteResize = (node, data) => {
    const { width, height } = data.style;
    if (!node.data || !width || !height) {
        return node;
    }
    const updated = { ...node, data: { ...node.data, width, height } };
    if (node.style && node.style.width && node.style.height) {
        updated.style = { ...node.style, width, height };
        // Kept for parity: the old code always reached this branch and set height to the width.
        updated.width = width;
        updated.height = width;
    }
    if (data.nodePosition) {
        updated.position = data.nodePosition;
    }
    return updated;
};

export const applyRemoteNodeUpdate = (node, data) => {
    if (node.id !== data.id) {
        return node;
    }
    if (data.position) {
        return { ...node, position: data.position };
    }
    if (data.name || data.name === '') {
        return { ...node, data: { ...node.data, label: data.name } };
    }
    if (data.bg) {
        return { ...node, data: { ...node.data, nodeBg: data.bg } };
    }
    if (data.textBg) {
        return { ...node, data: { ...node.data, textBg: data.textBg } };
    }
    if (data.type) {
        return { ...node, type: data.type };
    }
    if (data.PrevData) {
        return { ...node, data: data.PrevData, type: data.prevNodeType };
    }
    // The properties panel's border fields (D-045: borderWidth, borderStyle) and text style (D-047: fontFamily,
    // fontSize, fontWeight, textAlign).
    if (data.border || data.textStyle) {
        return { ...node, data: { ...node.data, ...data.border, ...data.textStyle } };
    }
    if (data.style) {
        return applyRemoteResize(node, data);
    }
    return node;
};

export const applyRemoteAllocatedColor = (node, data) => {
    if (node.creatorId !== data.userId) {
        return node;
    }
    return { ...node, data: { ...node.data, allocatedColor: data.nodeBg } };
};
